import ui from './ui'
import auth from './auth'
import menu from './menu'
import statistics from './statistics'
import product from './product'
import moduleAccess from './moduleAccess'
import documents from './documents'
import email from './email'
import onboarding from './onboarding'
import websites from './websites'
import apiKeys from './apiKeys'
import cms from './cms'
import catalogs from './catalogs'
import users from './users'
import roles from './roles'
import offices from './offices'
import brokers from './brokers'
import webhooks from './webhooks'
import permission from './permission'
import news from './news'
import tickets from './tickets'

export default {
  ...ui,
  ...auth,
  ...apiKeys,
  ...menu,
  ...statistics,
  ...product,
  ...moduleAccess,
  ...documents,
  ...email,
  ...onboarding,
  ...cms,
  ...websites,
  ...catalogs,
  ...users,
  ...roles,
  ...offices,
  ...brokers,
  ...webhooks,
  ...permission,
  ...news,
  ...tickets
}
